import { getCLS, getFID, getLCP } from 'web-vitals';
import { LCP_EVENT_TYPE, FID_EVENT_TYPE, CLS_EVENT_TYPE } from '../utils/constant';
export var WEB_VITAL_EVENT_PLUGIN_ID = 'com.amazonaws.rum.web-vitals';
var WebVitalsPlugin = /** @class */ (function () {
    function WebVitalsPlugin() {
        this.pluginId = WEB_VITAL_EVENT_PLUGIN_ID;
    }
    WebVitalsPlugin.prototype.load = function (context) {
        var _this = this;
        this.recordEvent = context.record;
        getLCP(function (data) { return _this.getWebVitalData(data, LCP_EVENT_TYPE); });
        getFID(function (data) { return _this.getWebVitalData(data, FID_EVENT_TYPE); });
        getCLS(function (data) { return _this.getWebVitalData(data, CLS_EVENT_TYPE); });
    };
    // tslint:disable-next-line:no-empty
    WebVitalsPlugin.prototype.enable = function () { };
    // tslint:disable-next-line:no-empty
    WebVitalsPlugin.prototype.disable = function () { };
    WebVitalsPlugin.prototype.getPluginId = function () {
        return this.pluginId;
    };
    // tslint:disable-next-line:no-empty
    WebVitalsPlugin.prototype.configure = function (config) { };
    WebVitalsPlugin.prototype.getWebVitalData = function (webVitalData, eventType) {
        var webVitalEvent = {
            version: '1.0.0',
            value: webVitalData.value
        };
        this.recordEvent(eventType, webVitalEvent);
    };
    return WebVitalsPlugin;
}());
export { WebVitalsPlugin };
